import { render, staticRenderFns } from "./BaseLeftDoubleIcon.vue?vue&type=template&id=3ade6ede"
import script from "./BaseLeftDoubleIcon.vue?vue&type=script&lang=js"
export * from "./BaseLeftDoubleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports